function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { INPUT } from "../../components/form-styles";
import { suggest, aiAvailable, onAiChange, AI_UNAVAILABLE_TEXT, friendly } from "./compose-api";
import { sanitizeHtml } from "./rich-text";

/*
 * "Write it for me" (2026-10-04). AiDraft: a button on hero / text / offer /
 * button sections opening a small panel (instructions → Draft → result with
 * Use this / Try again). SubjectSuggest: the same for subject + preheader in
 * the host editors. Nothing is applied until the person clicks "Use this".
 * The first 503 {error:"aiUnavailable"} shows one line and hides every button.
 */

const FIELD_LABEL = {
  subject: "Subject",
  preheader: "Preheader",
  headline: "Headline",
  subhead: "Subhead",
  html: "Text",
  buttonLabel: "Button label"
};
export class AiDraft extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "draft", async () => {
      const {
        kind,
        triggerType,
        sectionType,
        current,
        products
      } = this.props;
      this.setState({
        busy: true,
        err: null,
        result: null
      });
      try {
        const r = await suggest({
          kind,
          triggerType,
          sectionType,
          instructions: this.state.instructions.trim() || undefined,
          context: {
            products: (products || []).slice(0, 3).map(p => ({
              title: p.title,
              price: p.price
            })),
            current: current || {}
          }
        });
        if (this._alive) this.setState({
          busy: false,
          result: r || {}
        });
      } catch (e) {
        if (!this._alive) return;
        if (e && e.aiUnavailable) {
          this.setState({
            busy: false,
            unavailable: true,
            open: true
          });
          return;
        }
        this.setState({
          busy: false,
          err: friendly(e, "The draft didn't come back. Try again in a moment.")
        });
      }
    });
    this.state = {
      open: false,
      instructions: "",
      busy: false,
      result: null,
      err: null,
      unavailable: false
    };
    this._alive = true;
  }
  componentDidMount() {
    this._off = onAiChange(() => this._alive && this.forceUpdate());
  }
  componentWillUnmount() {
    this._alive = false;
    if (this._off) this._off();
  }
  render() {
    const {
      fields,
      onUse,
      label
    } = this.props;
    const {
      open,
      instructions,
      busy,
      result,
      err,
      unavailable
    } = this.state;
    if (unavailable) return /*#__PURE__*/React.createElement("div", {
      className: "cmp-ai-off"
    }, AI_UNAVAILABLE_TEXT);
    if (!aiAvailable()) return null;
    const keys = (fields || []).filter(k => result && result[k] != null && String(result[k]).trim());
    return /*#__PURE__*/React.createElement("div", {
      className: "cmp-ai"
    }, /*#__PURE__*/React.createElement("a", {
      className: "cmp-link ai",
      onClick: () => this.setState({
        open: !open
      })
    }, "\u2728 ", label || "Draft with AI"), open ? /*#__PURE__*/React.createElement("div", {
      className: "cmp-ai-panel"
    }, /*#__PURE__*/React.createElement("textarea", {
      style: {
        ...INPUT,
        minHeight: 48,
        resize: "vertical"
      },
      placeholder: "Optional: what should it say? e.g. warm, two sentences, mention free delivery",
      value: instructions,
      onChange: e => this.setState({
        instructions: e.target.value
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: "cmp-ai-actions"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "territory-toggle",
      style: {
        marginTop: 0
      },
      disabled: busy,
      onClick: this.draft
    }, busy ? "Drafting…" : result ? "Try again" : "Draft"), result && keys.length ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "territory-toggle primary",
      style: {
        marginTop: 0
      },
      onClick: () => {
        const patch = {};
        keys.forEach(k => {
          patch[k] = k === "html" ? sanitizeHtml(result[k]) : String(result[k]).trim();
        });
        onUse(patch);
        this.setState({
          open: false,
          result: null
        });
      }
    }, "Use this") : null, /*#__PURE__*/React.createElement("a", {
      className: "cmp-link dim",
      onClick: () => this.setState({
        open: false,
        result: null,
        err: null
      })
    }, "close")), err ? /*#__PURE__*/React.createElement("div", {
      className: "cmp-warn"
    }, err) : null, result ? keys.length ? /*#__PURE__*/React.createElement("div", {
      className: "cmp-ai-result"
    }, keys.map(k => /*#__PURE__*/React.createElement("div", {
      key: k
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, FIELD_LABEL[k] || k), k === "html" ? /*#__PURE__*/React.createElement("div", {
      className: "v html",
      dangerouslySetInnerHTML: {
        __html: sanitizeHtml(result[k])
      }
    }) : /*#__PURE__*/React.createElement("div", {
      className: "v"
    }, String(result[k])))), result.notes ? /*#__PURE__*/React.createElement("div", {
      className: "notes"
    }, result.notes) : null) : /*#__PURE__*/React.createElement("div", {
      className: "territory-hint",
      style: {
        margin: "6px 0 0"
      }
    }, "Nothing usable came back: try again with a hint.") : null) : null);
  }
}

/** Subject + preheader suggestion for the host editors. onUse({subject, preheader}). */
export function SubjectSuggest({
  kind,
  triggerType,
  subject,
  preheader,
  onUse,
  products
}) {
  return /*#__PURE__*/React.createElement(AiDraft, {
    label: "Suggest subject & preheader",
    sectionType: "subject",
    kind: kind,
    triggerType: triggerType,
    products: products,
    fields: ["subject", "preheader"],
    current: {
      subject: subject || "",
      preheader: preheader || ""
    },
    onUse: onUse
  });
}